// frontend/src/components/DocumentPicker/DocumentPicker.js
import React, { useEffect, useState } from "react";
import apiClient from "../../apiClient";

/**
 * DocumentPicker
 *
 * Props
 *  • clinicId            – vilken klinik som ska filtreras på
 *  • onGenerate(tmplObj) – callback när användaren klickar på en mall
 *  • excludeTemplateIds  – array<int> med mallar som redan är genererade
 */
function DocumentPicker({
  onGenerate,
  clinicId,
  excludeTemplateIds = [],          // <── ny prop
}) {
  const [templates, setTemplates] = useState([]);

  /* Hämta alla mallar för kliniken */
  useEffect(() => {
    apiClient
      .get("/api/document/templates", { params: { clinic_id: clinicId } })
      .then((res) => setTemplates(res.data))
      .catch((e) => console.error("Fel vid hämtning av dokumentmallar:", e));
  }, [clinicId]);

  /* Filtrera bort de som redan är öppnade */
  const available = templates.filter(
    (t) => !excludeTemplateIds.includes(t.template_id)
  );

  if (available.length === 0) {
    return <p>Alla dokumentmallar är redan genererade i denna session.</p>;
  }

  return (
    <div className="document-picker">
      <h3>Välj dokument att generera</h3>
      {available.map((t) => (
        <button
          key={t.template_id}
          className="document-btn primary-btn"
          onClick={() => onGenerate(t)}
        >
          {t.template_name}
        </button>
      ))}
    </div>
  );
}

export default DocumentPicker;
